import { enumBranchStyle } from "../constants";

export function IsPureVerticalStyle(branchStyle) {
  var pureVert = false;
  switch (branchStyle) {
    case enumBranchStyle.onecolumncenterright:
    case enumBranchStyle.onecolumncenterleft:
    case enumBranchStyle.onecolumnright:
    case enumBranchStyle.onecolumnleft:
      pureVert = true;
      break;
  }

  return pureVert;
}
